import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/api";
import { POLL_CURATION_MS } from "@/lib/realtime";
import { useIsBrandLive, useLiveRefetchInterval } from "@/lib/socket";
import type { UniverseGraph } from "@/types/brandUniverse.type";
import { brandUniverseGraphKey } from "./universeCache";

const BRAND_UNIVERSE_POLL_MS = 1000;

export function useBrandUniverseGraph(brandId: string | null, polling = false) {
  // Fact writes arrive as realtime events (api/universeRealtime.ts). Without a
  // live socket the graph falls back to its own slow poll, since the Universe
  // route doesn't mount the agent-runs fan-out.
  const live = useIsBrandLive(brandId);
  const liveInterval = useLiveRefetchInterval(brandId, POLL_CURATION_MS);
  return useQuery({
    queryKey: brandUniverseGraphKey(brandId),
    queryFn: async () => {
      const res = await axiosInstance.get<UniverseGraph>(
        `/brand/${brandId}/universe/graph`,
      );
      return res.data;
    },
    enabled: !!brandId,
    refetchInterval: polling ? BRAND_UNIVERSE_POLL_MS : liveInterval,
    refetchIntervalInBackground: polling,
    refetchOnWindowFocus: !live,
  });
}
